import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import TextField from '@mui/material/TextField';
import * as Cards from 'theme/components/Cards.style';
import * as Text from 'theme/components/Text.style';

export const CardSection = styled('div')`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  width: 100%;
`;

export const Card = styled(Cards.BasicCard)`
  align-items: center;
  border-radius: 40px;
  box-shadow: none;
  gap: 20px;
  max-width: 420px;
  padding: 20px;
  min-width: 370px;
  width: 100%;

  @media (max-width: ${breakpoints.mobileXL}) {
    max-width: 100%;
    min-width: 0;
  }
`;

export const Header = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
  text-align: center;
  width: 100%;
`;

export const FormInput = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const VerificationWrapper = styled.div`
  width: 100%;

  .vi__character {
    background-color: white;
    border: 2px solid ${colours.neutral[200]};
    border-radius: 50%;
    color: ${colours.neutral[900]};
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 50px;
    font-family: 'Inter', sans-serif;
    font-size: 24px;
    font-weight: 650;
    height: 50px;
    letter-spacing: -0.48px;
    max-width: 50px;
    overflow: hidden;
    width: 50px;

    @media (max-width: ${breakpoints.mobileM}) {
      flex: 0 0 40px;
      font-size: 20px;
      height: 35px;
      max-width: 35px;
      width: 35px;
    }
  }

  .vi__character--selected {
    border-color: ${colours.neutral[900]};
    outline: none;
  }

  .vi__character--inactive {
    background-color: white;
    color: transparent;
  }

  .vi__container {
    gap: 8px;
    height: auto;
    justify-content: center;
    width: 100% !important;

    input {
      font-size: 16px;
    }
  }
`;

export const InlineError = styled(Text.P1Semibold)`
  color: #ff383c;
  min-height: 30px;
  padding: 5px 10px;
  text-align: center;
  width: 100%;
`;

export const ResendCode = styled(Text.P1Semibold)`
  background: none;
  border: none;
  color: ${colours.neutral[800]};
  cursor: pointer;
  min-height: 30px;
  padding: 6px 10px;
`;

export const Input = styled(TextField)`
  background-color: white;
  border-radius: 25px;

  fieldset {
    border: 2px solid ${colours.neutral[200]};
    border-radius: 25px;
  }

  &:hover fieldset {
    border-color: ${colours.neutral[300]};
  }

  & .Mui-focused fieldset {
    border-color: ${colours.neutral[300]};
    border-width: 2px;
  }

  .MuiInputBase-root {
    padding: 0;
  }

  input {
    box-sizing: border-box;
    font-size: 16px;
    height: auto;
    line-height: 20px;
    padding: 15px 15px 15px 20px;

    &::placeholder {
      color: ${colours.neutral[500]};
      opacity: 1;
    }
  }

  .MuiInputLabel-root {
    display: none;
  }

  /* For Webkit browsers like Chrome, Safari */
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }

  /* For Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`;
